"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _CheckIcon = require("../Icons/CheckIcon");

var _WarningIcon = require("../Icons/WarningIcon");

var SnackbarIcon = function SnackbarIcon(_ref) {
  var icon = _ref.icon,
      type = _ref.type;
  if (icon) return /*#__PURE__*/_react["default"].cloneElement(icon, {
    color: "var(--snackbar-".concat(type, "-color)")
  });

  if (type === 'error') {
    return /*#__PURE__*/_react["default"].createElement(_WarningIcon.WarningIcon, {
      color: "var(--snackbar-error-color)",
      size: 16
    });
  }

  if (type === 'success') {
    return /*#__PURE__*/_react["default"].createElement(_CheckIcon.CheckIcon, {
      color: "var(--snackbar-success-color)",
      size: 16
    });
  }
};

exports.SnackbarIcon = SnackbarIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTbmFja2Jhckljb24iLCJpY29uIiwidHlwZSIsIlJlYWN0IiwiY2xvbmVFbGVtZW50IiwiY29sb3IiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbmFja2Jhci9TbmFja2Jhckljb24udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENoZWNrSWNvbiB9IGZyb20gJy4uL0ljb25zL0NoZWNrSWNvbic7XG5pbXBvcnQgeyBXYXJuaW5nSWNvbiB9IGZyb20gJy4uL0ljb25zL1dhcm5pbmdJY29uJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgaWNvbj86IEpTWC5FbGVtZW50O1xuICB0eXBlOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjb25zdCBTbmFja2Jhckljb246IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAoe1xuICBpY29uLFxuICB0eXBlLFxufSkgPT4ge1xuICBpZiAoaWNvbilcbiAgICByZXR1cm4gUmVhY3QuY2xvbmVFbGVtZW50KGljb24sIHtcbiAgICAgIGNvbG9yOiBgdmFyKC0tc25hY2tiYXItJHt0eXBlfS1jb2xvcilgLFxuICAgIH0pO1xuXG4gIGlmICh0eXBlID09PSAnZXJyb3InKSB7XG4gICAgcmV0dXJuIDxXYXJuaW5nSWNvbiBjb2xvcj1cInZhcigtLXNuYWNrYmFyLWVycm9yLWNvbG9yKVwiIHNpemU9ezE2fSAvPjtcbiAgfVxuICBpZiAodHlwZSA9PT0gJ3N1Y2Nlc3MnKSB7XG4gICAgcmV0dXJuIDxDaGVja0ljb24gY29sb3I9XCJ2YXIoLS1zbmFja2Jhci1zdWNjZXNzLWNvbG9yKVwiIHNpemU9ezE2fSAvPjtcbiAgfVxufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7O0FBT08sSUFBTUEsWUFBc0QsR0FBRyxTQUF6REEsWUFBeUQsT0FHaEU7RUFBQSxJQUZKQyxJQUVJLFFBRkpBLElBRUk7RUFBQSxJQURKQyxJQUNJLFFBREpBLElBQ0k7RUFDSixJQUFJRCxJQUFKLEVBQ0Usb0JBQU9FLGlCQUFBLENBQU1DLFlBQU4sQ0FBbUJILElBQW5CLEVBQXlCO0lBQzlCSSxLQUFLLDJCQUFvQkgsSUFBcEI7RUFEeUIsQ0FBekIsQ0FBUDs7RUFJRixJQUFJQSxJQUFJLEtBQUssT0FBYixFQUFzQjtJQUNwQixvQkFBTyxnQ0FBQyx3QkFBRDtNQUFhLEtBQUssRUFBQyw2QkFBbkI7TUFBaUQsSUFBSSxFQUFFO0lBQXZELEVBQVA7RUFDRDs7RUFDRCxJQUFJQSxJQUFJLEtBQUssU0FBYixFQUF3QjtJQUN0QixvQkFBTyxnQ0FBQyxvQkFBRDtNQUFXLEtBQUssRUFBQywrQkFBakI7TUFBaUQsSUFBSSxFQUFFO0lBQXZELEVBQVA7RUFDRDtBQUNGLENBZk0ifQ==